<section class="offers">
  <wl-commodity-offer-header
    class="header"
    [headerTitle]="content?.componentTitle"
    alignment="vertical"
  />
  <wl-commodity-offer-calculation-based-on
    class="consumption"
    variant="narrow"
    [label]="content?.calculationBasedOnLabel"
    [address]="supplyAddress"
    [consumptions]="consumptionValues"
    [electricityLabel]="'ElectricityUsageUnit' | translate"
    [gasLabel]="'GasUsageUnit' | translate"
    [adjustCalculationLabel]="content?.adjustCalculationLabel"
    (adjustCalculation)="adjustCalculation.emit()"
  />
  <div class="offer-card d-flex flex-column gap-6">
    <div class="segmented-control">
      @if (contractTypes && contractTypes.length > 1) {
        <span class="h6 d-block mb-1">{{
          content?.segmentedContractLabel
        }}</span>
        <wl-filter
          id="contract-types"
          [entries]="contractTypes"
          [selected]="initiallySelectedContract"
          (entrySelected)="showOffersOptions($event)"
          [styleIsStretched]="true"
        />
      }
      @if (offerOptions && offerOptions.length > 1) {
        <span class="h6 d-block mb-1 mt-2">{{
          content?.segmentedControlLabel
        }}</span>
        <wl-filter
          id="offer-options"
          [entries]="offerOptions"
          [selected]="initiallySelectedOfferOption"
          (entrySelected)="showOffer($event)"
          [styleIsStretched]="true"
        />
      }
    </div>

    <div>
      @switch (brand) {
        @case ('ed') {
          @if (shownOffer) {
            <ed-consumer-acquisition-commodity-offer
              class="d-block"
              [offer]="shownOffer"
              [content]="content"
              variant="card"
              [showMemberGetMember]="showMemberGetMember"
              [useAlternateCommodityTariffView]="
                !!content?.useAlternateCommodityTariffView
              "
              [hideCommodityProductBreakdownTable]="
                !!content?.hideCommodityProductBreakdownTable
              "
              [enableNewOfferCardTitles]="!!content?.enableNewOfferCardTitles"
              [termijnbedragVariantA]="!!content?.termijnbedragVariantA"
              [termijnbedragVariantB]="!!content?.termijnbedragVariantB"
              (selectOffer)="selectOffer.emit(shownOffer)"
              (openMoreInfo)="openMoreInfo.emit(shownOffer)"
              (viewTariffs)="viewTariffs.emit(shownOffer)"
            />
          } @else {
            <ed-consumer-acquisition-commodity-offer
              variant="card"
              [showLoadingState]="true"
            />
          }
        }
        @case ('essent') {
          @if (shownOffer) {
            <essent-consumer-acquisition-commodity-offer
              class="d-block"
              [offer]="shownOffer"
              [content]="content"
              variant="card"
              [showMemberGetMember]="showMemberGetMember"
              [useAlternateCommodityTariffView]="
                !!content?.useAlternateCommodityTariffView
              "
              [hideCommodityProductBreakdownTable]="
                !!content?.hideCommodityProductBreakdownTable
              "
              [enableNewOfferCardTitles]="!!content?.enableNewOfferCardTitles"
              [centerAlignedTariffLink]="!!content?.centerAlignedTariffLink"
              [termijnbedragVariantA]="!!content?.termijnbedragVariantA"
              [termijnbedragVariantB]="!!content?.termijnbedragVariantB"
              (selectOffer)="selectOffer.emit(shownOffer)"
              (openMoreInfo)="openMoreInfo.emit(shownOffer)"
              (viewTariffs)="viewTariffs.emit(shownOffer)"
            />
          } @else {
            <essent-consumer-acquisition-commodity-offer
              variant="card"
              [showLoadingState]="true"
            />
          }
        }
      }

      @if (content?.offerSaverShown) {
        @if (content?.offerSaver; as offerSaverContent) {
          <wl-offer-saver-button [content]="offerSaverContent" />
        }
      }
    </div>
  </div>
  <footer>
    <wl-rich-text-wrapper [field]="{ value: content?.componentFootNote }">
      <div></div>
    </wl-rich-text-wrapper>
  </footer>
</section>
